export const DATERANGE_FILTER_TEXT = {
	inputLabel: 'Departure date range',
	placeholder: 'dd.mm.yyyy',
	inputAriaLabel: 'Input calendar',
	calendarAriaLabel: 'Select calendar',
};
